import styled from "styled-components"

import {minWidthMedia} from "@irati/ui/src/global/media"
import {Hr} from "@irati/ui/src/Layout"
import Button from "@irati/ui/src/Button"
import Flex from "@irati/ui/src/Flex"

export const ResponsiveFlex = styled(Flex)`
  flex-direction: column;

  ${minWidthMedia.desktop`
    flex-direction: row;
    align-items: center;
  `}
`
export const ResponsiveButton = styled(Button)`
  margin-top: ${({theme}) => theme.spacing.oneAndHalf};

  ${minWidthMedia.desktop`
    margin: 0;
  `}
`
export const StyledHr = styled(Hr)`
  ${minWidthMedia.desktop`
    margin: 0;
  `}
`
export const StyledError = styled.div`
  text-align: center;
  margin-top: 10px;
`
